import { render, staticRenderFns } from "./RmbRate.vue?vue&type=template&id=00ce45f1&"
import script from "./RmbRate.vue?vue&type=script&lang=js&"
export * from "./RmbRate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports